import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { OrderHistory, RequestHistoryParams } from '../models';

export enum HistoryActionTypes {
  GetOrderHistoryAction = '[History] GetOrderHistoryAction',
  GetOrderHistorySuccessAction = '[History] GetOrderHistorySuccessAction',
  GetOrderHistoryErrorAction = '[History] GetOrderHistoryErrorAction',
  SetLoadingAction = '[History] SetLoadingAction',
  SetSkeletonLoadingAction = '[History] SetSkeletonLoadingAction',
  ClearStateAction = '[History] ClearStateAction',
}

export const GetOrderHistoryAction = createAction(
  HistoryActionTypes.GetOrderHistoryAction,
  props<{ params: RequestHistoryParams; showLoading: boolean }>()
);
export const GetOrderHistorySuccessAction = createAction(
  HistoryActionTypes.GetOrderHistorySuccessAction,
  props<{ orderHistory: OrderHistory }>()
);
export const GetOrderHistoryErrorAction = createAction(
  HistoryActionTypes.GetOrderHistoryErrorAction,
  props<{ failure: AppStateFailure }>()
);
export const setLoading = createAction(HistoryActionTypes.SetLoadingAction, props<{ isLoading: boolean }>());
export const setSkeletonLoading = createAction(HistoryActionTypes.SetSkeletonLoadingAction, props<{ isSkeletonLoading: boolean }>());
export const ClearStateAction = createAction(HistoryActionTypes.ClearStateAction, props<{ actionType: string }>());
